import useSWR, { type Fetcher } from 'swr';

import { ticketsList } from '~/data/generated/endpoints/tickets/tickets';
import { parseApiResponse } from '~/data/parseApiResponse';
import { type Ticket, ticketSchema } from '~/data/schemas/ticket';

const ticketsByInvoiceFetcher: Fetcher<
  Ticket[],
  readonly ['invoice', invoiceId: string, 'tickets']
> = async ([_, invoiceId]) => {
  // Scoped by invoice_id and unpaginated, so the endpoint returns a bare
  // Ticket[] today, but normalize the paginated envelope too (AMP-502).
  const { data } = await ticketsList({ invoice_id: invoiceId });
  const results = Array.isArray(data) ? data : data?.results;
  return parseApiResponse(ticketSchema.array(), results, 'InvoiceTickets');
};

export default function useInvoiceTickets(invoiceId: string | null) {
  const {
    data,
    error,
    isLoading: loading,
  } = useSWR(
    invoiceId ? (['invoice', invoiceId, 'tickets'] as const) : null,
    ticketsByInvoiceFetcher,
  );

  return { tickets: data, error, loading };
}
